import Vue from 'vue';

// v-dialogDrag: 弹窗拖拽
Vue.directive('dialogDrag', {
  bind(el, binding, vnode, oldVnode) {
    el = el || window.event;
    const dialogHeaderEl = el.querySelector('.el-dialog__header');
    const dragDom = el.querySelector('.el-dialog');
    dialogHeaderEl.style.cursor = 'move';

    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);

    dialogHeaderEl.onmousedown = (e) => {
      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - dialogHeaderEl.offsetLeft;
      const disY = e.clientY - dialogHeaderEl.offsetTop;

      // 获取到的值带px 正则匹配替换
      let styL, styT;

      // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
      if (sty.left.includes('%')) {
        styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100);
        styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100);
      } else {
        styL = +sty.left.replace(/px/g, '');
        styT = +sty.top.replace(/px/g, '');
      }

      document.onmousemove = function (e) {
        // 通过事件委托，计算移动的距离
        const clientWidth = document.body.clientWidth;
        const clientHeight = document.body.clientHeight;
        const l = e.clientX - disX;
        const t = e.clientY - disY;
        // 移动当前元素
        if(l + styL<0){
          dragDom.style.left='0px';
        }else if(l + styL>clientWidth-dragDom.offsetWidth){
          dragDom.style.left=clientWidth-dragDom.offsetWidth+'px';
        }else{
          dragDom.style.left = `${l + styL}px`;
        }
        if(t + styT<0){
          dragDom.style.top='0px';
        }else if(t + styT>clientHeight-dragDom.offsetHeight){
          dragDom.style.top=clientHeight-dragDom.offsetHeight+'px';
        }else{
          dragDom.style.top = `${t + styT}px`;
        }
        //将此时的位置传出去
        //binding.value({x:e.pageX,y:e.pageY})
      };

      document.onmouseup = function (e) {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    }
  }
})

// v-dialogDragWidth: 弹窗宽度拖大 拖小
Vue.directive('dialogDragWidth', {
  bind(el, binding, vnode, oldVnode) {
    const dragDom = binding.value.$el.querySelector('.el-dialog');

    el.onmousedown = (e) => {

      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - el.offsetLeft;

      document.onmousemove = function (e) {
        e.preventDefault(); // 移动时禁用默认事件

        // 通过事件委托，计算移动的距离
        const l = e.clientX - disX;
        dragDom.style.width = `${l}px`;
      };

      document.onmouseup = function (e) {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    }
  }
})
// 鼠标按下移动元素
Vue.directive('move', {
  bind(el, binding) {
    el.onmousedown = function (e) {
      let disx = e.pageX - el.offsetLeft;
      let disy = e.pageY - el.offsetTop;
      let elWidth = el.offsetWidth;
      let elHeight = el.offsetHeight;
      let elParentWidth = el.parentNode.parentNode.offsetWidth;
      let elParentHeight = el.parentNode.parentNode.offsetHeight;
      document.onmousemove = function (e) {
        // el.style.left = e.pageX - disx + 'px';
        // el.style.top = e.pageY - disy + 'px';
        let elLeft = e.pageX - disx;
        let elTop = e.pageY - disy;
        if (elLeft < -(elWidth-100)) {
          elLeft = -(elWidth-100);
        } else if (elLeft > elParentWidth - 100) {
          elLeft = elParentWidth - 100;
        }
        if (elTop < -100) {
          elTop = -100;
        } else if (elTop > elParentHeight - 100) {
          elTop = elParentHeight - 100;
        }
        el.style.marginLeft = elLeft + 'px';
        el.style.marginTop = elTop + 'px';
      }
      document.onmouseup = function () {
        document.onmousemove = document.onmouseup = null;
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/myComponents/directive.js